const messages = {
  _default: (field) => `Ang halaga ng ${field} ay hindi wasto`,
  after: (field, [target, inclusion]) => `Ang ${field} ay dapat pagkatapos ng ${inclusion ? 'o katumbas ng ' : ''}${target}`,
  alpha: (field) => `Ang ${field} ay dapat mga letra lamang`,
  alpha_dash: (field) => `Ang ${field} ay maaaring maglaman ng mga letra, numero, gitling, at underscore`,
  alpha_num: (field) => `Ang ${field} ay dapat mga letra at numero lamang`,
  alpha_spaces: (field) => `Ang ${field} ay maaaring maglaman ng mga letra at espasyo lamang`,
  before: (field, [target, inclusion]) => `Ang ${field} ay dapat bago ang ${inclusion ? 'o katumbas ng ' : ''}${target}`,
  between: (field, [min, max]) => `Ang ${field} ay dapat nasa pagitan ng ${min} at ${max}`,
  confirmed: (field) => `Ang kumpirmasyon ng ${field} ay hindi tugma`,
  credit_card: (field) => `Ang ${field} ay hindi wasto`,
  date_between: (field, [min, max]) => `Ang ${field} ay dapat nasa pagitan ng ${min} at ${max}`,
  date_format: (field, [format]) => `Ang ${field} ay dapat nasa format na ${format}`,
  decimal: (field, [decimals = '*'] = []) => `Ang ${field} ay dapat numero at maaaring maglaman ng${!decimals || decimals === '*' ? '' : ` ${decimals}`} decimal na puntos`,
  digits: (field, [length]) => `Ang ${field} ay dapat numero at eksaktong ${length} na digit`,
  dimensions: (field, [width, height]) => `Ang ${field} ay dapat ${width} pixels by ${height} pixels`,
  email: (field) => `Ang ${field} ay dapat wastong email`,
  excluded: (field) => `Ang ${field} ay dapat wastong halaga`,
  ext: (field) => `Ang ${field} ay dapat wastong file`,
  image: (field) => `Ang ${field} ay dapat larawan`,
  included: (field) => `Ang ${field} ay dapat wastong halaga`,
  integer: (field) => `Ang ${field} ay dapat integer`,
  ip: (field) => `Ang ${field} ay dapat wastong IP address`,
  ip_or_fqdn: (field) => `Ang ${field} ay dapat wastong IP address o FQDN`,
  length: (field, [length, max]) => {
    if (max) {
      return `Ang haba ng ${field} ay dapat nasa pagitan ng ${length} at ${max}`;
    }
    return `Ang haba ng ${field} ay dapat ${length}`;
  },
  max: (field, [length]) => `Ang ${field} ay hindi dapat higit sa ${length} na karakter`,
  max_value: (field, [max]) => `Ang ${field} ay dapat ${max} o mas mababa`,
  mimes: (field) => `Ang ${field} ay dapat may wastong uri ng file`,
  min: (field, [length]) => `Ang ${field} ay dapat hindi bababa sa ${length} na karakter`,
  min_value: (field, [min]) => `Ang ${field} ay dapat ${min} o mas mataas`,
  numeric: (field) => `Ang ${field} ay dapat mga numero lamang`,
  regex: (field) => `Ang format ng ${field} ay hindi wasto`,
  required: (field) => `Kinakailangan ang ${field}`,
  required_if: (field, [target]) => `Kinakailangan ang ${field} kapag ang ${target} ay may ganitong halaga`,
  url: (field) => `Ang ${field} ay hindi wastong URL`,
};

const locale = {
  name: 'tl',
  messages,
  attributes: {},
};

export default locale;
